import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import { TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT } from '@/configuration/tiers/tiersConf';

export default function transformer(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 0;
    serverTableData.orderBy = 'creationTime';
  }
  if (serverTableData.query?.sousType.length === 0) {
    serverTableData.query.sousType = [
      TIERS_SOUS_TYPE_FOURNISSEUR_SUPPORT,
    ];
  }
  return generalTransformer(serverTableData);
}
